import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";
import { rid } from "../../utils/shipinhao/utils";

export interface GetShipinhaoCollectionParams extends ActiomCommonParams {
    pageNum?: number;
    pageSize?: number;
}

export interface CollectionDetailResponse {
    data: {
        baseResp: { errcode: number };
        collectionList: CollectionDetail[];
        collectionListCount: number;
        hasHomepageTab: boolean;
    };
    errCode: number;
    errMsg: string;
}

export interface CollectionDetail {
    id: string;
    name: string;
    desc: string;
    coverImgUrl: string;
    createTime: number;
    totalReadCount: string;
    feedCount: number;
    spamFlag: number;
    closeTime: number;
    lastUpdateTime: number;
    invalidFeedCount: number;
    updateCoverUrlMaxCount: number;
    updateCoverUrlRemainCount: number;
    collectionType: number;
    auditOperRecommendFlag: number;
    showStatus: number;
    categoryInfo: {
        categoryId: string;
        categoryName: string;
    };
    courseInfo: {
        price: number;
        freeRange: number;
    };
    updateNameMaxCount: number;
    updateNameRemainCount: number;
    stickyOpStatus: number;
    missEpisodesInfo: {
        missEpisodeItems: any[];
        totalMissEpisodes: number;
    };
}

export type PublishAction = CommonAction<GetShipinhaoCollectionParams, CollectionDetailResponse["data"]>;

export const getShipinhaoCollection: PublishAction = async (_task, params) => {
    // 验证 extraParam 是否存在
    if (!params.extraParam) {
        return response(400, "缺少 extraParam 参数", {
            baseResp: { errcode: -1 },
            collectionList: [],
            collectionListCount: 0,
            hasHomepageTab: false,
        });
    }

    if (!params.extraParam.fingerPrintDeviceId || !params.extraParam.aId || !params.extraParam.uin) {
        return response(400, "fingerPrintDeviceId、aId和uin不能为空", {
            baseResp: { errcode: -1 },
            collectionList: [],
            collectionListCount: 0,
            hasHomepageTab: false,
        });
    }

    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://channels.weixin.qq.com/platform/post/finderNewLifeCreate",
        origin: "https://channels.weixin.qq.com",
        "content-type": "application/json",
        "finger-print-device-id": params.extraParam.fingerPrintDeviceId,
        "x-wechat-uin": params.extraParam.uin,
    };

    const http = new Http({
        headers,
    });

    const urlParams = new URLSearchParams({
        _aid: params.extraParam.aId,
        _rid: rid(),
        _pageUrl: "https://channels.weixin.qq.com/platform/post/finderNewLifeCreate",
    }).toString();

    const requestData = {
        pageNum: params.pageNum ?? 1,
        pageSize: params.pageSize ?? 20,
        timestamp: Date.now().toString(),
        _log_finder_uin: "",
        _log_finder_id: params.extraParam.finderUserName || "",
        rawKeyBuff: null,
        pluginSessionId: null,
        scene: 7,
        reqScene: 7,
    };

    const res = await http.api<CollectionDetailResponse>({
        method: "post",
        url: `https://channels.weixin.qq.com/micro/content/cgi-bin/mmfinderassistant-bin/collection/get_collection_list?${urlParams}`,
        data: requestData,
    });

    const isSuccess = res.errCode === 0;

    return response(isSuccess ? 0 : 414, res.errMsg, res.data);
};
